export enum BalanceHistoryType {
  DIAMOND = 'ton',
  COOKIE = 'cookie',
  UNDEFINED = '',
}
